/**
 * Designs queries
 */
import gql from 'graphql-tag'

export const getProduct3DFilesQuery = gql`
  query getProduct3DFiles($id: Int!) {
    product: product3DFiles(id: $id) {
        id
        name
        modelSize: model_size
        flatlock
        label
        defaultpredyed2
        zipperName: zipper_name
        zipperHidden: zipper_hidden
        zipper2Name: zipper2_name
        zipper2Hidden: zipper2_hidden
        bibraceFullPrint: bibrace_fullprint
        hasPredyed: has_predyed
        branding
        bibBrace {
            white
            black
        }
        binding {
            white
            black
        }
        zipper {
            white
            black
        }
        zipper2 {
            white
            black
        }
        obj
        mtl
        bumpMap: bump_map
        glbEnabled: glb_enabled
        glb
        extraMaterials: extra_materials
        flatlock_glb
        bibraceWhite_glb: bib_brace_white_glb
        bibraceNormal_glb: bib_brace_normal_glb
        bibraceBlack_glb: bib_brace_black_glb
        bindingWhite_glb: binding_white_glb
        bindingBlack_glb: binding_black_glb
        branding_glb_png
        branding2_glb_png
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/IntakeForm/PreviewAndDesignTemplate/data.ts